export type ResourceCalendarWeekGridTranslation = {
  elementColumn: string;
  fullDay: string;
  gridAriaLabel: string;
  phase: {
    assembly: string;
    disassembly: string;
  };
  processBusinessId: string;
  processOwner: string;
  status: {
    confirmed: string;
    free: string;
    tentative: string;
  };
  weekday: {
    friday: string;
    monday: string;
    saturday: string;
    sunday: string;
    thursday: string;
    tuesday: string;
    wednesday: string;
  };
};

export const resourceCalendarWeekGridTranslation: ResourceCalendarWeekGridTranslation = {
  elementColumn: 'Element',
  fullDay: 'Cały dzień',
  gridAriaLabel: 'Tygodniowy kalendarz zajętości elementów słownika',
  phase: {
    assembly: 'Montaż',
    disassembly: 'Demontaż',
  },
  processBusinessId: 'Identyfikator',
  processOwner: 'Opiekun procesu',
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny',
    tentative: 'Rezerwacja wstępna',
  },
  weekday: {
    friday: 'Pt',
    monday: 'Pn',
    saturday: 'So',
    sunday: 'Nd',
    thursday: 'Cz',
    tuesday: 'Wt',
    wednesday: 'Śr',
  },
};
